import { render, staticRenderFns } from "./keywordStatistics.vue?vue&type=template&id=3ac23008&scoped=true&"
import script from "./keywordStatistics.vue?vue&type=script&lang=ts&"
export * from "./keywordStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./keywordStatistics.vue?vue&type=style&index=0&id=3ac23008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac23008",
  null
  
)

export default component.exports